import {
  PostStripeProductLinkRequestBodyType,
  PostStripeProductLinkResponseBodyType,
} from "@intelligems/ig-types/functions/stripe-product-links";
import { adminKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const postStripeProductLink = async (
  data: ApiRequest<PostStripeProductLinkRequestBodyType>
) => {
  const resp = await api.post<
    PostStripeProductLinkResponseBodyType,
    PostStripeProductLinkRequestBodyType
  >(`/v2/admin/stripe-product-links`, data.body);
  return resp.data;
};

export const usePostStripeProductLink = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation<
    PostStripeProductLinkResponseBodyType,
    Error,
    ApiRequest<PostStripeProductLinkRequestBodyType>
  >({
    mutationFn: async (
      data: ApiRequest<PostStripeProductLinkRequestBodyType>
    ) => postStripeProductLink(data),
    onSuccess: async () => {
      if (id) {
        await queryClient.invalidateQueries({ queryKey: adminKeys.agency(id) });
      }
    },
  });
};
